.field {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.label {
  color: var(--foreground-light);
  display: block;
  font-size: var(--font-size-label);
  font-weight: var(--font-weight-semibold);
  margin-bottom: 4px;
}

.required {
  margin-inline-start: 4px;
}

.inputWrap {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
}

.control {
  width: 100%;
  height: 32px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--background-transparent-lighter);
  color: var(--foreground);
  font-size: var(--font-size-body);
  padding: 0 8px;
  outline: none;
  transition:
    border-color var(--motion-fast) linear,
    background-color var(--motion-fast) linear,
    box-shadow var(--motion-fast) linear;
}

/* Extra right padding so text doesn't slide under the eye button */
.controlWithReveal {
  padding-right: 36px;
}

.revealButton {
  position: absolute;
  right: 4px;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: transparent;
  border: none;
  color: var(--muted-foreground);
  cursor: pointer;
  line-height: 0;
  border-radius: var(--radius-sm);
  transition:
    color var(--motion-fast) linear,
    background-color var(--motion-fast) linear,
    box-shadow var(--motion-fast) linear;
}

.revealButton:hover {
  color: var(--foreground);
  background: color-mix(in oklab, var(--surface) 76%, var(--accent) 24%);
}

.revealButton:focus-visible {
  color: var(--foreground);
  box-shadow: var(--focus-ring-shadow);
}

.revealButton[aria-pressed="true"] {
  color: var(--foreground);
}

.fileControl {
  width: 100%;
  min-height: 32px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--background-transparent-lighter);
  color: var(--foreground);
  font-size: var(--font-size-body);
  padding: 6px 8px;
}

.textareaControl {
  width: 100%;
  min-height: 96px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--background-transparent-lighter);
  color: var(--foreground);
  font-size: var(--font-size-body);
  padding: 8px;
  resize: vertical;
}

.control::placeholder {
  color: var(--foreground-light);
  font-weight: var(--font-weight-medium);
}

.textareaControl::placeholder {
  color: var(--foreground-tertiary);
}

.control:disabled {
  color: var(--foreground-tertiary);
  cursor: not-allowed;
}

.control:focus {
  border-color: var(--color-blue);
}

.errorControl {
  border-color: var(--destructive);
}

.errorText {
  color: var(--destructive);
  font-size: var(--font-size-xs);
  margin-top: 1px;
  position: absolute;
}

.errorHelperWrap {
  min-height: 16px;
}

.hintText {
  color: var(--foreground-tertiary);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-regular);
  margin-top: 2px;
}

.hintTextDanger {
  color: var(--destructive);
}

.checkboxRoot {
  align-items: center;
  border-radius: var(--radius-md);
  cursor: pointer;
  display: inline-flex;
  gap: 8px;
  position: relative;
}

.checkboxHoverable {
  padding: 5px;
}

.checkboxLarge.checkboxHoverable {
  padding: 6px;
}

.checkboxHoverable:hover {
  background-color: var(--background-transparent-light);
}

.checkboxOn.checkboxHoverable:hover {
  background-color: var(--background-transparent-blue);
}

.checkboxDisabled.checkboxHoverable:hover {
  background-color: transparent;
}

.checkboxInput {
  height: 1px;
  margin: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  width: 1px;
}

.checkboxBox {
  align-items: center;
  background: transparent;
  border: 1px solid var(--foreground);
  border-radius: var(--t-border-radius-sm-round);
  corner-shape: round;
  box-sizing: border-box;
  color: var(--background);
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  position: relative;
}

.checkboxInput:focus-visible + .checkboxBox {
  box-shadow: var(--focus-ring-shadow);
}

.checkboxSmall .checkboxBox {
  height: 14px;
  width: 14px;
}

.checkboxLarge .checkboxBox {
  border-width: 1.43px;
  height: 20px;
  width: 20px;
}

.checkboxOn .checkboxBox {
  background: var(--color-blue);
  border-color: var(--color-blue);
}

.checkboxIcon {
  height: 14px;
  pointer-events: none;
  width: 14px;
}

.checkboxLarge .checkboxIcon {
  height: 20px;
  width: 20px;
}

.checkboxDisabled {
  cursor: not-allowed;
}

.checkboxDisabled .checkboxBox {
  border-color: var(--primary-border-40);
}

.checkboxDisabled.checkboxOn .checkboxBox {
  background: var(--color-blue-7);
  border-color: var(--color-blue-7);
}

.checkboxText {
  color: var(--foreground);
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-medium);
}
